"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.effectiveRoundBool = effectiveRoundBool;
exports.isShotgunRound = isShotgunRound;
exports.normalizeShotgunOrder = normalizeShotgunOrder;
exports.matchesShotgunOrder = matchesShotgunOrder;
exports.registrationInShotgunSlot = registrationInShotgunSlot;
exports.buildShotgunSlotElemMatch = buildShotgunSlotElemMatch;
/** Treat Mongo / form string booleans as real booleans */
function effectiveRoundBool(value) {
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'number')
        return value !== 0;
    if (typeof value === 'string') {
        const s = value.toLowerCase().trim();
        return s === 'true' || s === '1' || s === 'yes';
    }
    return false;
}
function isShotgunRound(roundConfig) {
    return effectiveRoundBool(roundConfig?.shotgunStart);
}
function normalizeShotgunOrder(order) {
    if (order === 'A')
        return 'A';
    if (order === 'B')
        return 'B';
    return null;
}
function matchesShotgunOrder(ttOrder, slotOrder) {
    if (slotOrder === 'A')
        return ttOrder === 'A' || ttOrder == null || ttOrder === '';
    if (slotOrder === 'B')
        return ttOrder === 'B';
    // legacy null slot: matches null/'' only
    return ttOrder == null || ttOrder === '';
}
function registrationInShotgunSlot(reg, roundNumber, startingHole, slotOrder) {
    if (!reg.teeTimes?.length)
        return false;
    return reg.teeTimes.some((tt) => tt.round === roundNumber &&
        tt.startingHole === startingHole &&
        matchesShotgunOrder(tt.shotgunOrder, slotOrder));
}
/** MongoDB roundScores.$elemMatch fragment for a shotgun starting-hole slot */
function buildShotgunSlotElemMatch(roundNumber, startingHole, slotOrder) {
    const base = {
        roundNumber,
        startingHole,
    };
    if (slotOrder === 'A') {
        return {
            ...base,
            $or: [
                { shotgunOrder: 'A' },
                { shotgunOrder: null },
                { shotgunOrder: '' },
                { shotgunOrder: { $exists: false } },
            ],
        };
    }
    if (slotOrder === 'B') {
        return { ...base, shotgunOrder: 'B' };
    }
    // legacy null slot
    return {
        ...base,
        $or: [
            { shotgunOrder: null },
            { shotgunOrder: '' },
            { shotgunOrder: { $exists: false } },
        ],
    };
}
